// extracted by mini-css-extract-plugin
export var active = "_72-b";
export var activeIndicator = "_72-6";
export var animate = "_72-a";
export var disabled = "_72-c";
export var flat = "_72-1";
export var fullWidth = "_72-3";
export var lg = "_72-9";
export var md = "_72-8";
export var redoButtonTabGroup = "_72-0";
export var sm = "_72-7";
export var tabButton = "_72-4";
export var tabButtonsContainer = "_72-2";
export var xs = "_72-5";